import api from './api';

async function getVacancyResponsesAPI(vacancyId: string, viewed: string, recomendation: string) {
  const response = await api.get(
    `admin_vacancy/${vacancyId}/responses/?viewedByResponsible=${viewed}&withRecommendation=${recomendation}`,
  );
  return response?.data;
}

export default getVacancyResponsesAPI;
